import React, { Suspense, useEffect } from 'react';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import ScrollRestoration from './1.Ui/components/page/ScrollRestoration';
import { useRestorePagePosition } from './1.Ui/hooks/utils/useRestorePagePosition';

const Home = React.lazy(() => import("./1.Ui/screens/home/home"));
const FoodDetails = React.lazy(() => import("./1.Ui/screens/food/food-details"));


function App() {

  const { clearPosition } = useRestorePagePosition()

  useEffect(() => {
    clearPosition()
  }, [])

  return (
    <>
      <Suspense fallback={""}>
        <Router >
          <ScrollRestoration />
          <Switch >
            <Route path="/" exact>
              <Home />
            </Route>
            <Route path="/introduce/:categoryId/:foodId">
              <FoodDetails />
            </Route>
          </Switch>
        </Router>
      </Suspense>
    </>
  );

}

export default App;
